import { LMcategories, ApiLMcategories, EngineCategory, ApiEngineCategory } from "./types";

export const parseAPILMcategories = (apiLMcategories: ApiLMcategories): LMcategories => {
    return {
        engineCategories: apiLMcategories.engineCategories,
        recommendedCategories: apiLMcategories.recommendedCategories,
        showRecommended: apiLMcategories.showRecommended

    }
}

export const parseAPIEngineCategory = (apiEngineCategory: ApiEngineCategory[]): EngineCategory[] => {
    return apiEngineCategory.map(apiEngineCategoryItem => {
        return {
            id: apiEngineCategoryItem.categoryId,
            name: apiEngineCategoryItem.displayName,

        }
    })
}